<div class="separador"> </div>

<div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <div class="navbar-light bg-light border-right  cabboton" id="sidebar-wrapper">
      <div class="sidebar-heading">{{fecdia | date: 'dd/MM/yyyy'}}</div>
      <div class="sidebar-heading"></div>
      <div class="sidebar-heading"></div>
      <div class="list-group list-group-flush">
        <a class="list-group-item list-group-item-action bg-light"
                 [routerLink]="mnu.ruta"  
              *ngFor="let mnu of menu; let i=index">
              <fa-icon [icon]="mnu.icono"></fa-icon> 
             {{mnu.nombre}}
        </a>
      </div>
    </div>
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
        <nav class="navbar navbar-expand-lg navbar-light bg-cave border-bottom  cabboton">
                <button class="btn  btn-light" (click)="persiana()" id="menu-toggle"><span class="navbar-toggler-icon"></span></button>
                <span class="usuario">{{nomusu}} </span>                 
        </nav>
        <div class="container-fluid">
              <div class="titular">
                  <h1>Entregas de Piensos</h1>
                 <hr>
              </div>

              <div class="sellista cabboton container">  
                    <button  class="btn btn-cave" (click)="volver()">
                        <fa-icon [icon]="icoRet"></fa-icon>  Volver
                     </button>
                     <button style="margin-left:5px;" class="btn btn-success"  onClick="window.print()">
                        <fa-icon [icon]="icoPrn"></fa-icon>  Imprimir
                     </button>
              </div>
   
              <div class="sellista cabboton">
                  <h3 class="display-6 tiplista" >Tipo de Gráfico</h3>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="graf0" name="tipolista" (click)="tipoGraf(0)" [checked]="SwGrf0">
                      <label class="custom-control-label" for="graf0">Producción</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="graf1" name="tipolista" (click)="tipoGraf(1)" [checked]="SwGrf1">
                      <label class="custom-control-label" for="graf1">Precios</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="graf2" name="tipolista" (click)="tipoGraf(2)" [checked]="SwGrf2">
                      <label class="custom-control-label" for="graf2">Importes</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="graf3" name="tipolista" (click)="tipoGraf(3)" [checked]="SwGrf3">
                      <label class="custom-control-label" for="graf3">Producción Totales</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="graf4" name="tipolista" (click)="tipoGraf(4)" [checked]="SwGrf4">
                      <label class="custom-control-label" for="graf4">Importes Totales</label>
                  </div>
            </div>     
              <hr class="cabboton">
              <div style="text-align: center;">
                    <div *ngIf="resul" class="spinner-border text-primary" role="status"></div>
              </div>

              <div style="text-align: center;">
                   <h5 class="tipsocio">{{nomusu}}</h5>
              </div>

              <div *ngIf="SwLinGr" class="sellista">
                   <highcharts-chart
                      [Highcharts] = "lineaGrafico" 
                      [options] = "opcionesLinea" 
                      style = "display: block;">
                   </highcharts-chart>
              </div>
              <div *ngIf="SwTarGr" class="sellista">
                <highcharts-chart
                   [Highcharts] = "tartaGrafico" 
                   [options] = "opcionesTarta" 
                   style = "display: block;">
                </highcharts-chart>
           </div>

        </div>
    </div>
    <!-- /#page-content-wrapper -->
</div>
  




